import styled from 'styled-components';

export const Wrap = styled.div`
  width: 100%;
`;

export const TableRow = styled.div<{ direction?: 'row' | 'columns' }>`
  box-sizing: border-box;
  padding: 8px 20px;
  width: 100%;
  display: ${(props) => (props.direction === 'row' ? 'flex' : 'block')};
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  order: 0;
  flex-grow: 0;
`;

export const TableHead = styled.div<{ direction?: 'row' | 'columns' }>`
  min-width: 80px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #a7a7a7;
`;

export const TableBody = styled.div<{type?: 'default' | 'thin', underline?: boolean}>`
  font-weight: ${props => props.type === 'thin' ? '500' : '600' };
  font-size: ${props => props.type === 'thin' ? '14px' : '18px' };
  line-height: 24px;
  color: ${props => props.type === 'thin' ? '#696969' : '#383838' };
  flex: none;

  width: calc(100% - 80px);
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  
  
  ${props => props.underline && `
    > p {
        text-decoration: underline;
    }
  `}
`;

export const Content = styled.p`
    > strong {
      font-weight: bold;
    }

    > b {
      font-weight: bold;
    }
`

// -webkit-line-clamp: 2;
// overflow: hidden;
// width: ${(props) => (props.direction === 'row' ? '80px' : '100%')};
  